import { useMemo, useEffect, useState } from 'react';
import { isScheduleActiveNow } from 'shared/helpers/schedule';
import { GqlGetCollectionsNavigationQuery } from 'types/graphql';

type Collection = NonNullable<GqlGetCollectionsNavigationQuery['getCollectionsNavigation']>[number];

type UseActiveCollectionsOptions = {
  collections: Collection[];
  dispensaryTimezone?: string | null;
  enablePolling?: boolean;
  pollingIntervalMs?: number;
};

export function useActiveCollections({
  collections,
  dispensaryTimezone = 'UTC',
  enablePolling = false,
  pollingIntervalMs = 60000,
}: UseActiveCollectionsOptions): Collection[] {
  const timezone = dispensaryTimezone ?? 'UTC';
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!enablePolling) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      setTick((prev) => prev + 1);
    }, pollingIntervalMs);

    return () => clearInterval(intervalId);
  }, [enablePolling, pollingIntervalMs]);

  const activeCollections = useMemo(() => {
    // Force re-computation when tick changes during polling
    void tick;

    return collections.filter((collection) => {
      if (!collection.schedule) {
        return true;
      }

      return isScheduleActiveNow(collection.schedule, timezone);
    });
  }, [collections, timezone, tick]);

  return activeCollections;
}
